import api from './api';
import { Patient, PaginatedResponse } from '../types';

export const patientService = {
  async getAll(params?: {
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Patient>> {
    const response = await api.get('/patients', { params });
    return response.data;
  },

  async getById(id: string): Promise<Patient> {
    const response = await api.get(`/patients/${id}`);
    return response.data;
  },

  async search(term: string): Promise<Patient[]> {
    const response = await api.get('/patients/search', { params: { term } });
    return response.data;
  },

  async create(data: Partial<Patient>): Promise<Patient> {
    const response = await api.post('/patients', data);
    return response.data;
  },

  async update(id: string, data: Partial<Patient>): Promise<Patient> {
    const response = await api.patch(`/patients/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/patients/${id}`);
  },

  async getAppointmentHistory(id: string) {
    const response = await api.get(`/patients/${id}/appointments`);
    return response.data;
  },
};
